import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss',
    standalone: false
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup = this.fb.group({
    username: ['', Validators.required],
    password: ['', Validators.required]
  });

  loginError: string | null = null;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {}

  onLogin(): void {
    this.loginError = null;
    if (this.loginForm.valid) {
      this.authService.login(this.loginForm.value).subscribe(
        (response: any) => {
          this.authService.setToken(response.jwt);
          this.authService.setUserDetails(response.user);
          const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home/inventory/articles';
          this.router.navigate([returnUrl]);
        },
        () => {
          this.loginError = 'Contraseña o usuario incorrecto.';
        }
      );
    }
  }

  onInputChange() {
    this.loginError = null;
  }
}
